import { AlertDeliveryTypes } from '../typings/enums';
// This will also determine the order
export var ALLOWED_DELIVERY_METHODS = [
    AlertDeliveryTypes.Text,
    AlertDeliveryTypes.Email
];
export var LobType;
(function (LobType) {
    LobType["RC"] = "RC";
    LobType["PSCC"] = "PSCC";
})(LobType || (LobType = {}));
export var AlertIDType;
(function (AlertIDType) {
    AlertIDType["ALL"] = "all";
    AlertIDType["AVAILABLE_CREDIT"] = "AVAILABLE_CREDIT";
    AlertIDType["AUTOPAY_CANCEL"] = "AUTOPAY_CANCEL";
    AlertIDType["BALANCE_EXCEEDS"] = "BALANCE_EXCEEDS";
    AlertIDType["BALANCE_OVERLIMIT"] = "BALANCE_OVERLIMIT";
    AlertIDType["INTERNATIONAL_TRANSACTION"] = "INTERNATIONAL_TRANSACTION";
    AlertIDType["PAYMENT_REMINDER"] = "PAYMENT_REMINDER";
    AlertIDType["PROMO_PURCHASE_EXPIRY"] = "PROMO_PURCHASE_EXPIRY";
    AlertIDType["TRANSACTION_CARD_NOT_PRESENT"] = "TRANSACTION_CARD_NOT_PRESENT";
    AlertIDType["TRANSACTION_OVER_USER_CREDITLIMIT"] = "TRANSACTION_OVER_USER_CREDITLIMIT";
    AlertIDType["TRANSACTION_REFUND"] = "TRANSACTION_REFUND";
    AlertIDType["TRANSACTION_DECLINE"] = "TRANSACTION_DECLINE";
    AlertIDType["PURCHASE_EXCEEDS"] = "PURCHASE_EXCEEDS";
    AlertIDType["TRANSACTION_AUTHORIZATION"] = "TRANSACTION_AUTHORIZATION";
    AlertIDType["APPROVED_TRANSACTIONS"] = "APPROVED_TRANSACTIONS";
    AlertIDType["SPECIAL_FINANCING"] = "SPECIAL_FINANCING";
    AlertIDType["MOCK_ID"] = "MOCK_ID";
    AlertIDType["SYF_PAY_LATER"] = "SYF_PAY_LATER";
    AlertIDType["INSTALLMENT_CREDIT_PAYMENT_REMINDER"] = "INSTALLMENT_CREDIT_PAYMENT_REMINDER";
    AlertIDType["INSTALLMENT_CREDIT_AUTOPAY_REMINDER"] = "INSTALLMENT_CREDIT_AUTOPAY_REMINDER";
    AlertIDType["INSTALLMENT_CREDIT_PAYMENT_RETURNED"] = "INSTALLMENT_CREDIT_PAYMENT_RETURNED";
    AlertIDType["INSTALLMENT_CREDIT_ACCOUNT_SUMMARY"] = "INSTALLMENT_CREDIT_ACCOUNT_SUMMARY";
    AlertIDType["PAYMENT_POSTED"] = "PAYMENT_POSTED";
    AlertIDType["PAYMENT_SCHEDULED"] = "PAYMENT_SCHEDULED";
    AlertIDType["AUTOPAY_ENROLL"] = "AUTOPAY_ENROLL";
    AlertIDType["AUTOPAY_MODIFY"] = "AUTOPAY_MODIFY";
    AlertIDType["INSTALLMENT_CREDIT_LOAN_COMPLETE"] = "INSTALLMENT_CREDIT_LOAN_COMPLETE";
})(AlertIDType || (AlertIDType = {}));
export var ALERTS_CATEGORIES = {
    paymentAlerts: [
        AlertIDType.PAYMENT_REMINDER,
        AlertIDType.PROMO_PURCHASE_EXPIRY
    ],
    balanceAlerts: [
        AlertIDType.BALANCE_OVERLIMIT,
        AlertIDType.BALANCE_EXCEEDS,
        AlertIDType.AVAILABLE_CREDIT
    ],
    spendingAlerts: [
        AlertIDType.APPROVED_TRANSACTIONS,
        AlertIDType.TRANSACTION_DECLINE,
        AlertIDType.TRANSACTION_REFUND
    ],
    payLaterAlerts: [AlertIDType.SYF_PAY_LATER]
};
export var APPROVED_TRANSACTIONS = [
    AlertIDType.TRANSACTION_AUTHORIZATION,
    AlertIDType.PURCHASE_EXCEEDS
];
export var SYF_PAY_LATER = [
    AlertIDType.INSTALLMENT_CREDIT_PAYMENT_REMINDER,
    AlertIDType.INSTALLMENT_CREDIT_AUTOPAY_REMINDER,
    AlertIDType.INSTALLMENT_CREDIT_PAYMENT_RETURNED,
    AlertIDType.INSTALLMENT_CREDIT_ACCOUNT_SUMMARY,
    AlertIDType.PAYMENT_POSTED,
    AlertIDType.PAYMENT_SCHEDULED,
    AlertIDType.AUTOPAY_ENROLL,
    AlertIDType.AUTOPAY_CANCEL,
    AlertIDType.AUTOPAY_MODIFY,
    AlertIDType.INSTALLMENT_CREDIT_LOAN_COMPLETE
];
export var PAYMENT_REMINDER_MAX_DAYS = 20;
export var TEXT_FIELD_DEFAULT_VALUE = '0.01';
export var SELECT_FIELD_DEFAULT_VALUE = '5';
export var ACCORDION_TRANSITION_DURATION = 0.6;
export var FieldType;
(function (FieldType) {
    FieldType["TextField"] = "textField";
    FieldType["SelectField"] = "selectField";
})(FieldType || (FieldType = {}));
export var BRAND_OPTIONS = [
    { label: 'Amazon', value: 'amazon', lob: LobType.RC },
    { label: 'American Eagle', value: 'aeoutfitters', lob: LobType.RC },
    { label: 'Belk', value: 'belk', lob: LobType.RC },
    { label: 'CheapO Air', value: 'cheapoair', lob: LobType.RC },
    { label: 'Crate & Barrel', value: 'cb', lob: LobType.RC },
    { label: 'Dicks Sporting Goods', value: 'dicks', lob: LobType.RC },
    { label: 'Google', value: 'google', lob: LobType.RC },
    { label: 'Harbor Freight ', value: 'hft', lob: LobType.RC },
    { label: 'JCPenney ', value: 'jcpenney', lob: LobType.RC },
    { label: 'Lowes', value: 'lowes', lob: LobType.RC },
    { label: "Sam's Club", value: 'sams', lob: LobType.RC },
    { label: 'SYF MC', value: 'tru', lob: LobType.RC },
    { label: 'TJX', value: 'tjx', lob: LobType.RC },
    { label: 'Verizon', value: 'verizon', lob: LobType.RC },
    { label: 'Virgin Red', value: 'virgin', lob: LobType.RC },
    { label: 'Walgreens', value: 'walgreens', lob: LobType.RC },
    { label: 'Zetail', value: 'zetail', lob: LobType.RC },
    { label: 'Paysol', value: 'paysol', lob: LobType.PSCC }
];
export var SECURITY_ALERTS = ['profile_change', 'auto_pay'];
export var SupportedLanguage;
(function (SupportedLanguage) {
    SupportedLanguage["EN"] = "en";
    SupportedLanguage["ES"] = "es";
})(SupportedLanguage || (SupportedLanguage = {}));
export var TEXT_ALERTS_TERMS_AND_CONDITIONS = {
    EN: 'assets/alerts/en/syf_text_email_policy.pdf',
    ES: 'assets/alerts/es/syf_text_email_policy.pdf'
};
export var IMAGE_ASSET_PATHS = {
    ERROR_IMAGE: 'assets/alerts/cloud-transparent-120.gif',
    ALERT_NOT_FOUND: 'assets/alerts/notAvailable.svg',
    MARKETING_PRIVACY_ERROR_IMAGE: 'assets/alerts/cat-error.svg'
};
export var HOST_PATHS = {
    LOCAL: 'https://dev.synchronycredit.com'
};
export var PlatformType;
(function (PlatformType) {
    PlatformType["ESS"] = "ess";
    PlatformType["MSS"] = "mss";
    PlatformType["DIGITAL_SERVICING"] = "digital-servicing";
    PlatformType["PEAKS"] = "digital-servicing-pre-login";
})(PlatformType || (PlatformType = {}));
export var StorageType;
(function (StorageType) {
    StorageType["ACCESS_TOKEN"] = "accessToken";
    StorageType["LANGUAGE"] = "language";
    StorageType["CORRELATION_ID"] = "correlationId";
    StorageType["SELECTED_ENV"] = "alerts-selected-env";
    StorageType["SELECTED_CLIENT_TYPE"] = "alerts-selected-type";
})(StorageType || (StorageType = {}));
export var AccountIdType;
(function (AccountIdType) {
    AccountIdType["GUID"] = "guid";
})(AccountIdType || (AccountIdType = {}));
export var ViewType;
(function (ViewType) {
    ViewType["ALERTS_MFE"] = "Alerts MFE";
    ViewType["PREFERENCE_CENTER"] = "Preference Center";
})(ViewType || (ViewType = {}));
export var SYF_LOGO = 'https://dev.synchronycredit.com/assets/synchrony/logo.svg';
export var PAYPAL_CLIENT_LIST = ['paypal', 'paypalcredit', 'ebay'];
export var RESTRICTED_PRODUCT_TYPE = ['INSTALLMENT_LOAN'];
export var PAY_LATER_PRODUCT_TYPE = [
    'INSTALLMENT_LOAN_MONTHLY',
    'INSTALLMENT_LOAN_PAY_IN_FOUR'
];
